<template>
  <v-container class="mb-12">
    <v-row justify="center">
      <Logo></Logo>
    </v-row>

    <h1 class="text-center mb-4">Login</h1>

    <v-row justify="center">
      <v-card class="mb-7" width="400">
        <v-card-text>
          <v-form @submit.prevent="handleInput">
            <v-text-field
                v-model="password"
                label="Password"
                outlined
                type="password"
                append-icon="mdi-key"
                :error-messages="error"
                hint="Enter password for access"
                persistent-hint
                autocomplete="current-password"
            >
            </v-text-field>

            <v-row justify="center">
              <v-btn @click="handleInput" color="primary" class="mt-2" large>Login</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import Logo from "./Logo";
  import { mapActions } from 'vuex';

  export default {
    name: "Login",
    components: {
      Logo
    },
    data() {
      return {
        password: '',
        error: null
      }
    },
    methods: {
      ...mapActions([ 'login' ]),

      async handleInput() {
        if (this.password) {
          try {
            await this.login(this.password);
          } catch (e) {
            this.error = 'Wrong password';
            setTimeout(() => this.error = null, 1500)
          }
        } else {
          this.error = 'May not be empty';
          setTimeout(() => this.error = null, 1500);
        }
      }
    }
  }
</script>
